import {
  TextField,
  Box,
  FormGroup,
  FormHelperText,
  FormLabel,
  Checkbox,
  FormControlLabel
} from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../../app/hooks";
import { editSubTypeDetail } from "../../../../../services/varianceService/model/varianceRequest/VarianceRequestSlice";
import { IncidentSubTypeDetail } from "../../../../../services/varianceService/model/varianceRequest/IncidentSubTypeDetail";
import "../../../styles/IncidentSubTypeStyle.css";

interface ISubtypeDetailOptions {
  incidentType: string;
  options: { name: string; description: string }[];
  formName: string;
  freeformName?: string;
  freeformLabel?: string;
  helperText?: number;
  canEdit: boolean;
}

function IncidentSubTypeDetails({
  incidentType,
  options,
  formName,
  freeformName,
  freeformLabel,
  helperText = 0,
  canEdit,
}: ISubtypeDetailOptions): JSX.Element {
  const dispatch = useDispatch();
  const incidentSubTypeDetails = useAppSelector(
    (state) => state.varianceRequest.varianceRequest.incidentSubTypeDetails
  ) || [];
  const IncidentSubTypes: IncidentSubTypeDetail[] = options.map((option) => ({
    name: option.name,
    checked:
      incidentSubTypeDetails.find((x) => x.name === option.name)?.checked ?? false,
    description: option.description,
  }));
  const [SubTypeDetailOptions, setSubTypeDetailOptions] = React.useState({
    IncidentSubTypes,
  });
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const incidentSubTypeDetail: IncidentSubTypeDetail = {
      name: event.target.name,
      checked: event.target.checked,
      incidentType: incidentType,
      description:
        (event.target.labels && event.target.labels[0]?.textContent) || "",
    };
    setSubTypeDetailOptions((prevOptions) => ({
      ...prevOptions,
      IncidentSubTypes: prevOptions.IncidentSubTypes.map((option) =>
        option.name === event.target.name
          ? { ...option, checked: event.target.checked }
          : option
      ),
    }));
    dispatch(editSubTypeDetail(incidentSubTypeDetail));
  };
  const [freeForm, setFreeForm] = React.useState(
    incidentSubTypeDetails.find((x) => x.name === freeformName)?.description || ""
  );
  const setOther = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const incidentSubTypeDetail: IncidentSubTypeDetail = {
      name: event.target.name,
      checked: true,
      description: event.target.value,
    };
    setFreeForm(incidentSubTypeDetail.description);
    dispatch(editSubTypeDetail(incidentSubTypeDetail));
  };

  return (
    <React.Fragment>
      <Box
        mt={2}
        mb={2}
        sx={{
          display: "flex",
          flexDirection: "column",
          ml: 3,
          overflowX: "auto",
        }}
      >
        <FormHelperText>
          {helperText === 0
            ? ""
            : helperText === 1
            ? "Please select only one option"
            : "Select One or More"}
        </FormHelperText>
        <FormLabel component="legend">{formName}</FormLabel>
        <FormGroup>
          {SubTypeDetailOptions.IncidentSubTypes.map((value) => (
            <FormControlLabel
              key={value.name}
              label={value.description}
              control={
                <Checkbox
                  disabled={!canEdit}
                  checked={value.checked || false}
                  name={value.name}
                  onChange={(e) => handleChange(e)}
                />
              }
            />
          ))}
          {freeformName !== undefined && (
            <TextField
              disabled={!canEdit}
              id="standard-basic"
              name={freeformName}
              label={freeformLabel || "Other"}
              variant="standard"
              value={freeForm}
              onChange={setOther}
            />
          )}
        </FormGroup>
      </Box>
    </React.Fragment>
  );
}

export { IncidentSubTypeDetails };
  

